import React from 'react';
import './styles.css';

const Badge = ({ text, variant = "default" }) => {
    return <span className={`costomBadge ${variant}`}>{text}</span>;
};

const UncategorizedContainer = ({ list = [], count = 0 }) => {

    return (
        <div className="container-fluid">
            <div className='title-container'>
                <div className="title">Unmapped</div>
                <Badge text={`${count} Items`} variant="red" />
            </div>
            <div className='uncat-border'>
                <div className="costomBadge-container">
                    {list.length > 0 ? (
                        list.map((data, index) => <Badge key={index} text={data?.name || data} />)
                    ) : (
                        <p className="no-items">No items available</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UncategorizedContainer;
